import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat, findArrayObject, amountFormatOnly, isEmpty, getDateInStringDDMMMYYYY, numberWithCommas, numberWithCommasInput, checkNumberOnly, replaceCommas, sortByDisplay, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../Dialog/Dialog';
import Radio from '@material-ui/core/Radio';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab
} from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import AmountInput from '../Inputs/AmountInput'
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  addPartyCharge,
} from "../../../store/actions/tripActionCreator";
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
import inputStyles from '../css/inputs'
import { trackDwebEvent } from '../../analytics';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AddDriver from '../AddDialogComponent/AddDialogComponent';
import addStyles from '../css/addEditTrip';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import { OnChange } from 'react-final-form-listeners';
import { data } from 'jquery';
import * as logger from '../../../logger';
import TextInputState from '../Inputs/TextInputState';
import AddIcon from '@material-ui/icons/Add';
import { VerifiedBankAccount, UnVerifiedBankAccount,TripBalanceReport,PassBookReport } from '../TopCard/icons';
import PassBookIcon from '../../../assets/passbook.svg';
import TripBalanceIcon from '../../../assets/trip-balance.svg';

const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  switchControl: {
    marginTop: 16,
    marginBottom: 8
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  expenseTypeListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%'
  },
  addExpenseListItem: {
    padding: '12px 15px',
    margin: 0,
    backgroundColor: '#0b1323',
    color: '#fff',
    fontWeight: 300,
    minHeight: 46,
    width: '100%',
    maxHeight: 46
  },
  addExpenseIcon: {
    color: '#fff',
    marginRight: 10
  },
  cherveRightIcon: {
    marginLeft: 10,
    float: 'right',
    color: '#fff'
  },
  listBoxAutoCompelete: {
    margin: 0,
    padding: 0
  },
  listBoxOption: {
    padding: 0,
    minHeight: 46,
    maxHeight: 46,
    borderBottom: '1px solid #eaedf3',
    "&:first-child": {
    },
    "&:last-child": {
    }
  },
  popUpIndicator: {
    display: 'none'
  },
  infoDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  nameDiv: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },
  subTitleSec: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  subTitleTxt: {
    fontSize: 14,
    fontWeight: 600,
    color: "#000",
    marginTop:16
  },
  driverDetailsDiv: {
    padding: "16px 24px",
    borderRadius: 8,
    border: "solid 1px #dcdcdc",
    backgroundColor: " #ededed",
    marginBottom: 24,
    marginTop: 2
  },
  titleV2: {
    fontSize: 14,
    fontWeight: 600,
    color: '#6b778c',
    marginBottom: 4
  },
  newInput: {
    backgroundColor: '#fff',
    border: "solid 1px #dedede",
    "& .MuiInputBase-input": {
      paddingTop: 12,
      paddingBottom: 12
    }
  },
  formControlInput: {
    marginBottom: 16
  },
  selectionDiv: {
    marginBottom: 8,
    marginLeft: 0,
    marginRight: 0,
    padding: 16,
    borderRadius: 8,
    display:'flex',
    alignItems:"center",
    cursor:"pointer",
    justifyContent:'space-between'
  },
  primary: {
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'capitalize',
  },
  secondary: {
    textTransform: 'capitalize',
    fontSize: 14
  },
  titleDiv: {
    display: "flex",
    alignItems: 'center',
  },
  verifiedAccount: {
    fontSize: 12,
    color: "rgba(21, 128, 38, 0.6)"
  },
  unVerifiedAccount: {
    fontSize: 12,
    color: "#e93333"
  },
  addBankDetailsButton: {
    marginTop: 24,
    padding: "12px 16px",
    borderRadius: 4,
    border: "solid 1px #0033cc",
    backgroundColor: "#fff",
    fontSize: 16,
    fontWeight: 600,
    color: "#0033cc",
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#fff",
    }
  },
  widthV1: {
    minWidth: 152
  },
  saveButtonDisabled: {
    backgroundColor: '#dadada !important',
    color: '#5e636c !important',
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    fontSize: 14,
    fontWeight: 300,
    height: 36,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#dadada'
    }
  },
  selectionDivIcons:{
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    flexDirection:'row'
  },
  dialog:{
    maxWidth:'352px'
  }
}));
const CardSelectionDialog = (props) => {
  let ifscRegex = "^[A-Z]{4}0[A-Z0-9]{6}$";
  const componentClasses = useStyles();
  let submit
  const {
    user,
    type,
    selectedData,
    onConfirm,
    classes,
    open,
    onClose,
    onSave,
    defaultSelected,
    location,
    calledFromInfo,
    title,
    ...other
  } = props;
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const handleClose = (status) => {
    onClose(status);
  };
  const getIcons= (type)=>{
    switch (type) {
        case "trip":
            return <TripBalanceReport />;
        case  "passbook":
            return <PassBookReport />;
        default:
            return null
      }
  }
  const options= [
    {
      value:'trip',
      title:'Trip Balance Report',
      bg:"#e5f3ef"
    },
    {
      value:'passbook',
      title:'Passbook Report',
      bg:"#e5ebfa",
    },
  ]
  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        classes={{
          paperWidthXs:componentClasses.dialog
        }}
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"title-for-select-card-details"}
        open={open}
      >
        <DialogTitle id={"title-for-select-card-details"} onClose={handleClose}>
          {title?title:'Select a value'}
        </DialogTitle>
        <TripActionDialogContent dividers>
          <div  className={componentClasses.selectionDivIcons} >
            {options && options.map((val,index)=>{
              return <div key={index} onClick={(e)=>{handleClose(val.value)}}>
                <div style={{display:'flex',alignItems:'center', justifyContent:'center',flexDirection:'column',cursor:'pointer'}}>
                  {val && val.value =="trip"?<img src={TripBalanceIcon} />:null}
                  {val && val.value =="passbook"?<img src={PassBookIcon} />:null}
                  <div className={componentClasses.subTitleTxt}>{val.title?val.title:""}</div>
                </div>
              </div>
            })}
          </div>
        </TripActionDialogContent>
      </Dialog>
    </div>
  );
}
const CardSelectionDialogWithRouter = withRouter(CardSelectionDialog);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardSelectionDialogWithRouter);